export const CLEAR_CQL_FILTER = "CLEAR_CQL_FILTER";

export const clearCqlFilterAction = () => {
    return {
        type: CLEAR_CQL_FILTER,
    };
};
